import React from 'react';
import { BookOpenIcon, GiftIcon, PickaxeIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '5 exclusive bonuses'
}, {
  icon: PickaxeIcon,
  label: '+450 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and educators'
}];
export function SocialProof() {
  return <section className="bg-earth-700 py-5" aria-label="What the teacher ready includes" data-id="element-221" data-mp="3f4wsm8gmzlg">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-cream sm:justify-between" data-id="element-222" data-mp="8dy8c946sgiz">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-223" data-mp="3ut99qs8p0l44">
            <Icon className="h-5 w-5 text-gold-400" aria-hidden="true" data-id="element-224" data-mp="3ur68td6057km" /> {label}
          </span>)}
      </div>
    </section>;
}